/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function TransactionHistory(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                viewBox='0 0 25.01 25.04'
                xmlns='http://www.w3.org/2000/svg'
            >
                <title>TransHistory</title>
                <g
                    data-name='Layer 2'
                    id='Layer_2'
                >
                    <g
                        data-name='Layer 1'
                        fill={iconColor || '#000'}
                        id='Layer_1-2'
                    >
                        <path d='M12.47,25a12.41,12.41,0,0,1-10-5.11.51.51,0,0,1,.82-.59,11.41,11.41,0,0,0,12.23,4.29A11.53,11.53,0,0,0,24,12.69a.5.5,0,0,1,.5-.49h0a.5.5,0,0,1,.5.51,12.56,12.56,0,0,1-9.27,11.9A12.72,12.72,0,0,1,12.47,25Z' />
                        <polygon points='2.64 22.24 3.04 19.86 5.43 20.26 4.58 19.07 2.2 18.68 1.8 21.06 2.64 22.24' />
                        <path d='M.5,12.85h0a.52.52,0,0,1-.5-.52A12.5,12.5,0,0,1,22.58,5.11a.51.51,0,0,1-.82.6A11.41,11.41,0,0,0,9.53,1.41,11.53,11.53,0,0,0,1,12.35.51.51,0,0,1,.5,12.85Z' />
                        <polygon points='22.36 2.8 21.96 5.19 19.58 4.79 20.42 5.97 22.81 6.37 23.21 3.98 22.36 2.8' />
                        <g id='Path-3'>
                            <path d='M16.46,16.33a.51.51,0,0,1-.28-.09l-4.82-3.17V6a.5.5,0,1,1,1,0v6.49l4.38,2.88a.5.5,0,0,1,.14.7A.48.48,0,0,1,16.46,16.33Z' />
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}